import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Work from '../../../interfaces/work';
import Event from '../../../interfaces/event';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faTractor } from '@fortawesome/pro-solid-svg-icons';
import css from './index.module.css';

interface Props {
  title: string;
  works: Work[];
  events: Event[];
}

export default function DayTitle({ title, works, events }: Props) {
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) => t('pages.dashboard.calendar.'.concat(key)),
    [t]
  );

  return (
    <div className={css['title']} data-name="day-title">
      <div className={css['date']}>{title}</div>

      <div className={css['details']}>
        {works?.length > 0 && (
          <span className={css['works']}>
            <FontAwesomeIcon icon={faTractor} />
            <span className={css['count']}>{works.length}</span>
            <span>{tp(works.length > 1 ? 'work_plural' : 'work_one')}</span>
          </span>
        )}
        {events?.length > 0 && (
          <span className={css['events']}>
            <FontAwesomeIcon icon={faBell} />
            <span className={css['count']}>{events.length}</span>
            <span>{tp(events.length > 1 ? 'event_plural' : 'event_one')}</span>
          </span>
        )}
      </div>
    </div>
  );
}
